module.exports = __webpack_public_path__ + "img/search.74d89305.svg";